// extracted by mini-css-extract-plugin
export default {"checkboxLabel":"Checkbox_checkboxLabel__gx64S"};